import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { BASE_URL } from "../utils/reportsHelpers";

const useRecentReports = (currentUser, limit = 8) => {
  const [recent, setRecent] = useState([]);
  const [recentLoading, setRecentLoading] = useState(true);

  const fetchRecent = useCallback(async () => {
    if (!currentUser) return;
    setRecentLoading(true);
    try {
      const res = await apiFetch(`${BASE_URL}/reports/history?infinityCode=${currentUser}&limit=${limit}`, { method: "GET" });
      const data = await res.json();
      setRecent(data.history || []);
    } catch {
      // non-critical section — fail quiet
    } finally {
      setRecentLoading(false);
    }
  }, [currentUser, limit]);

  useEffect(() => { fetchRecent(); }, [fetchRecent]);

  return { recent, recentLoading, refetchRecent: fetchRecent };
};

export default useRecentReports;
